module.exports = __webpack_public_path__ + "img/txt-ic.d114c308.svg";